module.exports = __webpack_public_path__ + "img/happy_clients_bw.09b8fc7.webp";